import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { decorahConfig } from "./data";

export default function DecorahPage() {
  return <CityPageTemplate config={decorahConfig} />;
}